import { atom } from "recoil";

const fleetWorkOrderAtom = atom({

    key: "fleetWorkOrder",
    default: {
        serviceBundle: { data: [], note: '' },
        serviceList: { data: [], note: '' },
        materialList: { data: [], note: '' },
        otherList: { data: [], note: '' },
        technicianCost: '0',
        estimatedCompletionDate: '',
        estimatedCompletionTime: '',
        estimatedExpirationDate: '',
        images: []
    }

});

export default fleetWorkOrderAtom;